import { createColumnHelper } from '@tanstack/table-core'
import { theme } from 'Providers/ThemeProvider'
import { NA } from 'constans/common'
import { useMemo } from 'react'
import { Table, Text } from 'shared/components'
import DateTimeCell from 'shared/components/DateTimeCell'
import { TemAccumumationModel } from 'types/customers'

interface TemAccumulationHistoriesProps {
  data?: TemAccumumationModel[]
}

const TemAccumulationHistories = ({ data }: TemAccumulationHistoriesProps) => {
  const columnsHelper = createColumnHelper<TemAccumumationModel>()
  const columns = useMemo(() => {
    return [
      columnsHelper.accessor('TransactionId', {
        header: 'Mã bill',
        cell: row => <Text>{row.getValue() || NA}</Text>,
      }),
      columnsHelper.accessor('TransactionType', {
        header: 'Loại giao dịch',
        cell: row => {
          return (
            <Text>{row.getValue() === 1 ? 'Tích tem' : 'Trừ tem' || NA}</Text>
          )
        },
      }),
      columnsHelper.accessor('TemQuantity', {
        header: 'Số lượng tem ',
        cell: ({ row: { original } }) => (
          <Text
            sx={{
              color:
                theme.palette[
                  original.TransactionType === 1 ? 'success' : 'error'
                ].main,
            }}
          >
            {original.TemQuantity || NA}
          </Text>
        ),
      }),
      columnsHelper.accessor('CreatedDate', {
        header: 'Ngày giao dịch',
        cell: row => <DateTimeCell value={row.getValue()} />,
      }),
    ]
  }, [columnsHelper])
  return (
    <Table columns={columns} data={data || []} heading="Lịch sử tích tem" />
  )
}

export default TemAccumulationHistories
